module.exports = __webpack_public_path__ + "img/MilitaryTechBackgroundC06_ua.648d2c71.webp";